var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './video-card.styles';
import { classMap } from 'lit-html/directives/class-map.js';
let PVideoCard = class PVideoCard extends LitElement {
    constructor() {
        super(...arguments);
        this.videoBaseUrl = '';
    }
    static { this.styles = styles; }
    /**
     * First updated lifecycle
     * @returns {void}
     */
    async firstUpdated() {
        this.accessToken = window.getAccessToken();
        if (this.videoId) {
            this.video = await this.getVideo(parseInt(this.videoId));
            if (!this.image && this.video?.poster) {
                this.image = this.video.poster;
            }
            if (!this.heading && this.video?.name) {
                this.heading = this.video.name;
            }
            if (!this.description && this.video?.description) {
                this.description = this.video.description;
            }
            if (!this.link && this.video) {
                this.link = `${this.videoBaseUrl}/${this.video.id}`;
                this.isVideo = true;
            }
        }
    }
    /**
     * Get video
     *
     * @param {number} id - Video id
     * @returns {Promise<any>} Video
     */
    async getVideo(id) {
        try {
            const response = await fetch(`${process.env.API_URL}/file/${id}?fields=any&access_token=${this.accessToken}`);
            const json = await response.json();
            return json[0];
        }
        catch (e) {
            console.error(e);
        }
        return [];
    }
    /**
     *
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        const classes = {
            'is-video': this.isVideo,
            'hide-text': this.hideText,
            preview: this.preview
        };
        return html ` <article class="video-card${classMap(classes)}"> <a href=${this.link}> <figure> ${this.image ? html `<img src=${this.image} alt=${this.alt} draggable="false" />` : ''}
            ${this.isVideo
            ? html ` <svg class="play" aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" > <circle cx="20" cy="20" r="20" fill="black" fill-opacity="0.6"></circle> <path d="M28.5 19.634C29.1667 20.0189 29.1667 20.9811 28.5 21.366L15.75 28.7272C15.0833 29.1121 14.25 28.631 14.25 27.8612L14.25 13.1388C14.25 12.369 15.0833 11.8879 15.75 12.2728L28.5 19.634Z" fill="white" ></path> </svg> `
            : ''}
          </figure>
          <div class="content ${this.hideText ? 'sr-only' : ''}">
            <h2>${this.heading}</h2>
            ${this.description ? html `<p>${this.description}</p>` : ''}
          </div>
        </a>
      </article>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true, attribute: 'video-id' })
], PVideoCard.prototype, "videoId", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoCard.prototype, "heading", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoCard.prototype, "image", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoCard.prototype, "link", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoCard.prototype, "description", void 0);
__decorate([
    property({ type: String, reflect: true })
], PVideoCard.prototype, "alt", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], PVideoCard.prototype, "preview", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'video-base-url' })
], PVideoCard.prototype, "videoBaseUrl", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'is-video' })
], PVideoCard.prototype, "isVideo", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'hide-text' })
], PVideoCard.prototype, "hideText", void 0);
PVideoCard = __decorate([
    customElement('p-video-card')
    /**
     * PVideoCard component
     *
     * @class PVideoCard
     * @typedef {PVideoHeroCard}
     * @extends {LitElement}
     */
], PVideoCard);
export { PVideoCard };
